import React from "react";
import { Link, NavLink } from "react-router-dom";
import { blogPosts } from "../data/blogPosts";
import "../styles/Home.css"; // Importieren Sie Ihre CSS-Datei für Home
const Home = () => {
  // Überprüfen Sie, ob blogPosts verfügbar ist
  const latestPosts = blogPosts?.slice(0, 3) || [];
  return (
    <div className="container">
      <div className="homecontent">
        <h1>Only Muscles</h1>
        <div class="homemain">  
          <div class="hometxt">
            <p>Entdecken Sie eine Vielzahl von Übungen, um Ihre Muskeln gezielt zu erreichen. Nutzen Sie unsere Filter, um die besten Übungen für Ihre Bedürfnisse zu finden.</p>
            <p>Besuchen Sie die <NavLink to="/exercises">Übungen-Seite</NavLink>, um loszulegen!</p>
            <p>Bitte beachten Sie, an jeder Bewegung sind wesentlich mehr Muskeln beteiligt als in Primär / Sekundär / Tertiär aufgeführt werden. Es werden dort nur die Muskeln genannt die hauptsächlich beteiligt sind.</p>
          </div>
          <div class="news">  
          {latestPosts.length > 0 && (
          <>
            
            <div className="blog-posts">
              {latestPosts.map((post) => (
                <div key={post.id} className="blog-post">
                  <h3>{post.title}</h3>
                  <p>{post.excerpt}</p>
                  <Link to={`/blog/${post.id}`}>Weiterlesen</Link>
                </div>
              ))}
            </div>
          </>
          )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;